import React from 'react';
import PropTypes from "prop-types";
import useDocumentFirestore from "@web/hooks/useDocumentFirestore";

ItemData.propTypes = {
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
};

function ItemData({component, dataField, ...props}) {
  // console.log("ItemData:activeAppPath:", props.path);
  const databaseItem =
    useDocumentFirestore((props[dataField]) ? "" : props.path);

  if (!databaseItem && !props[dataField]) {
    return null;
  }

  return React.createElement(component, {
    ...props,
    [dataField || "data"]: props[dataField] || databaseItem[0] || null,
  });
}

export default ItemData;
